import { jwtDecode } from 'jwt-decode'
import type { AdminJwtPayload } from '../types/admin'

const TOKEN_KEY = 'admin_jwt_token'

export const adminAuth = {
  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY)
  },

  setToken(token: string) {
    localStorage.setItem(TOKEN_KEY, token)
  },

  clearToken() {
    localStorage.removeItem(TOKEN_KEY)
  },

  isAuthenticated(): boolean {
    const token = this.getToken()
    if (!token) return false

    try {
      const payload = jwtDecode<AdminJwtPayload>(token)
      return payload.role === 'admin' && payload.exp * 1000 > Date.now()
    } catch {
      return false
    }
  },
}
